import { apiRequest } from './client'
import type { Paginated, Project, ProjectActiveTimer, ProjectDetail, ProjectStatus, TimeEntry } from './types'

export const projectsApi = {
  list: (params: { status?: ProjectStatus; search?: string; page?: number; pageSize?: number } = {}) =>
    apiRequest<Paginated<Project>>('/projects', { query: params }),

  get: (id: string) => apiRequest<{ data: ProjectDetail }>(`/projects/${id}`),

  create: (input: {
    name: string
    description?: string
    status?: ProjectStatus
    startDate?: string
    targetDate?: string
    color?: string
    icon?: string
    memberUserIds?: string[]
    memberRoleIds?: string[]
  }) => apiRequest<{ data: ProjectDetail }>('/projects', { method: 'POST', body: input }),

  update: (
    id: string,
    input: Partial<{
      name: string
      description: string
      status: ProjectStatus
      startDate: string | null
      targetDate: string | null
      color: string
      icon: string
      progress: number
    }>,
  ) => apiRequest<{ data: ProjectDetail }>(`/projects/${id}`, { method: 'PATCH', body: input }),

  setMembers: (id: string, userIds: string[]) =>
    apiRequest<{ data: ProjectDetail }>(`/projects/${id}/members`, { method: 'PATCH', body: { userIds } }),

  setRoles: (id: string, roleIds: string[]) =>
    apiRequest<{ data: ProjectDetail }>(`/projects/${id}/roles`, { method: 'PATCH', body: { roleIds } }),

  remove: (id: string) => apiRequest<{ data: { success: boolean } }>(`/projects/${id}`, { method: 'DELETE' }),

  getActiveTimers: (id: string) => apiRequest<{ data: ProjectActiveTimer[] }>(`/projects/${id}/time/active`),
  getTimeSummary: (id: string) => apiRequest<{ data: { totalSeconds: number } }>(`/projects/${id}/time/summary`),
  startTimer: (id: string) => apiRequest<{ data: TimeEntry }>(`/projects/${id}/time/start`, { method: 'POST', body: {} }),
  stopTimer: (id: string) => apiRequest<{ data: TimeEntry }>(`/projects/${id}/time/stop`, { method: 'POST', body: {} }),
}
